import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { ImageResourceDTO } from '../../model/ImageResourceDTO';
import { getProperSize } from '../../helpers/images';

import { find } from 'lodash-es';

@Component
export class GalleryCrossFadingImagesItem extends BaseComponent {
	@Prop() resource: ImageResourceDTO[];
	@Prop() sizes: string;
	@Prop() description: boolean;
	@Prop() count: number;

	get src() {
		return this.formatImageUrl(getProperSize(this.resource, 1000).path);
	}

	get srcset() {
		return this.resource.map(r => `${this.formatImageUrl(r.path)} ${r.width}w`).join(", ");
	}

	get alt() {
		let alt = find(this.resource, function (o) { return o.description != null });
		return alt ? alt.description : "";
	}

	getClass() {
		return `glr-image glr-image-${this.count}`;
	}
}

export default GalleryCrossFadingImagesItem;
